module.exports = __webpack_public_path__ + "img/arrow-down.1bdb6a0b.svg";